
import Clipboard from 'clipboard'


const FUNC = ( $Glb , Vue ) => {
  // 获取设备环境
  $Glb.device = function(){
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return {
      'isAndroid':isAndroid,
      'isiOS':isiOS
    }
  }

  $Glb.gopay = function( query ){
    this.$router.push({
      path: '/pay/index.html',
      query: query
    })
  }

  $Glb.USERDATA = function(){
    const userObj = {}
    if( window.localStorage[ 'GLB_ROOT_USER_$INDEX' ] ){
      let $INDEX = window.localStorage[ 'GLB_ROOT_USER_$INDEX' ].split(',')
      for( let i=0; i<$INDEX.length; i++ ){
        userObj[ $INDEX[ i ].toLowerCase() ] = window.localStorage[ `GLB_ROOT_USER_${ $INDEX[ i ] }` ] || ''
      }
      return userObj
    }else{
      return {}
    }
  }

  $Glb.copyWecat = function ( cln  ){
    var clipboard = new Clipboard( cln );
        clipboard.on("success", e => {
          $Glb.PlMessage("复制成功", 800, function() {
            window.location.href = "weixin://";
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", e => {
          // 不支持复制
          $Glb.PlMessage("该浏览器不支持一键复制,请长按手动复制", 800);
          // 释放内存
          clipboard.destroy();
        });
  }

	$Glb.urlquery = function (variable){
      var query = window.location.href.slice(window.location.href.indexOf('?')).substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }

  $Glb.getAttribute = function(){
    var obj = {};
    function getQD(){
      let arr = window.location.pathname.split('/').filter(Boolean);
      if(arr.length>3){
        return arr[2]
      }else{
        return $Glb.urlquery('qd')||window.localStorage[ 'GLB_ROOT_QD' ]||''
        // return $Glb.urlquery('qd')||window.localStorage[ `${arr.toUpperCase()}_ROOT_QD` ]||''
      }
    }
    function getPosid(){
      let arr = window.location.pathname.split('/')[1];
      // return $Glb.urlquery('posId')||$Glb.urlquery('posid')||''
      return $Glb.urlquery('posId')||$Glb.urlquery('posid')||window.localStorage[ `${arr.toUpperCase()}_ROOT_POSID` ]||window.localStorage[ 'GLB_ROOT_POSID' ]||''
      // return $Glb.urlquery('posId')||$Glb.urlquery('posid')||window.localStorage[ `${arr.toUpperCase()}_ROOT_POSID` ]||''
    }
    // GLB_ROOT_QD 和 GLB_ROOT_POSID 会在 pl_errhandle 组件里保存


    function getPathName(){
      let urlArr = window.location.pathname.split('/');
      return urlArr[1]
    }
    obj['pathName'] = getPathName()



    obj['posId'] = getPosid()
    obj['qd'] = getQD()
    return obj
  }

  $Glb.baiduCount = function(label,even){
    label = label+'-'+(this.getAttribute().qd==''?'未知渠道':'渠道:'+this.getAttribute().qd);
    window._hmt && window._hmt.push(['_trackEvent', label, even||'click']);
  }
  $Glb.getDay = function(){
    let mydate=new Date();
    let myddy=mydate.getDay();//获取存储当前日期
    let weekday=["周日","周一","周二","周三","周四","周五","周六"];
    return weekday[myddy]
  }






}



export default FUNC







// WEBPACK FOOTER //
// ./src/plugins/glb_function/index.js